import { Input as BaseInput, Error, ErrorConnector, HelpText, Label, RequiredStar } from "../common";
import { marginX, media } from "../../../styles";
import React from "react";
import { SharedInputProps } from "../Input";
import styled from "styled-components";
export type DateProps = React.InputHTMLAttributes<HTMLInputElement> & SharedInputProps;
const Input = styled(BaseInput)`
  &::-webkit-datetime-edit-text {
    ${marginX.xs}
  }
  @media ${media.hoverable} {
    &::-webkit-datetime-edit {
      &:hover {
        cursor: text;
      }
    }
    &::-webkit-calendar-picker-indicator {
      &:hover {
        cursor: pointer;
      }
    }
  }
`;
export function Date({
  error,
  helpText,
  label,
  ...props
}: DateProps) {
  const {
    id,
    required
  } = props;
  const hasError = !!error;
  return <>
      <Label htmlFor={id} data-sentry-element="Label" data-sentry-source-file="Date.tsx">
        {label}
        {required ? <RequiredStar /> : null}
      </Label>
      <HelpText data-sentry-element="HelpText" data-sentry-source-file="Date.tsx">{helpText}</HelpText>
      <Container data-sentry-element="Container" data-sentry-source-file="Date.tsx">
        <ErrorConnector show={hasError} data-sentry-element="ErrorConnector" data-sentry-source-file="Date.tsx">
          <Input type="date" error={hasError} aria-required={required} {...props} data-sentry-element="Input" data-sentry-source-file="Date.tsx" />
          {error ? <Error>{error}</Error> : null}
        </ErrorConnector>
      </Container>
    </>;
}
const Container = styled.div`
  width: 100%;
`;
export default Date;